import { render, staticRenderFns } from "./grade.vue?vue&type=template&id=3c517407&scoped=true&"
import script from "./grade.vue?vue&type=script&lang=js&"
export * from "./grade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c517407",
  null
  
)

export default component.exports